import React from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ButtonGroup,
  ModalOverlay,
  useDisclosure,
  Box,
} from "@chakra-ui/react";

function ConfirmationButton({
  title,
  verb,
  buttonTitle,
  buttonColor,
  buttonVariant,
  isDisabled,
  callback,
  isVisible = true,
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  if (!isVisible) return null;

  const modalBg = 'white';
  const headerBg = 'gray.50';
  const borderColor = 'gray.200';
  const overlayBg = 'blackAlpha.300';
  const boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)';
  return (
    <>
      <Button
        data-tour-id="action-start"
        variant={buttonVariant}
        isDisabled={isDisabled}
        onClick={onOpen}
        size="sm"
        colorScheme={buttonColor}
        _hover={{
          transform: 'translateY(-2px)',
          boxShadow: 'lg',
        }}
        transition="all 0.3s ease"
      >
        {title}
      </Button>
      <Modal
        isCentered
        returnFocusOnClose={false}
        isOpen={isOpen}
        onClose={onClose}
        closeOnBlur={false}
        size="md"
      >
        <ModalOverlay
          bg={overlayBg}
          backdropFilter='blur(10px)'
        />
        <ModalContent
          bg={modalBg}
          borderRadius="2xl"
          boxShadow={boxShadow}
          border="1px solid"
          borderColor={borderColor}
        >
          <Box
            bg={headerBg}
            borderTopRadius="2xl"
            borderBottom="1px solid"
            borderColor={borderColor}
          >
            <ModalHeader
              fontWeight="bold"
              fontSize="lg"
              py={4}
            >
              İşlemi Onayla
            </ModalHeader>
            <ModalCloseButton
              top={4}
              right={4}
              _hover={{
                bg: 'red.100',
                color: 'red.600'
              }}
              borderRadius="full"
            />
          </Box>
          <ModalBody py={6}>
            Bu işlem geri alınamaz {verb} istediğinizden emin misiniz?
          </ModalBody>
          <ModalFooter
            display="flex"
            justifyContent="flex-end"
            borderTop="1px solid"
            borderColor={borderColor}
            bg={headerBg}
            borderBottomRadius="2xl"
            py={4}
          >
            <ButtonGroup size="sm" spacing={3}>
              <Button
                onClick={onClose}
                colorScheme="gray"
                variant="outline"
                _hover={{
                  transform: 'translateY(-1px)',
                  boxShadow: 'md'
                }}
                transition="all 0.2s ease"
              >
                Vazgeç
              </Button>
              <Button
                colorScheme="green"
                onClick={() => {
                  callback();
                  onClose();
                }}
                _hover={{
                  transform: 'translateY(-1px)',
                  boxShadow: 'md'
                }}
                transition="all 0.2s ease"
              >
                {buttonTitle}
              </Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default ConfirmationButton;
